import { STRING_UOM } from '@/main/app.constants';
import type { StatisticColumn } from '@/trendData/trendData.constants';

/**
 * Extracts statistic values from a spikecatcher response table by matching headers to
 * explicit headerName fields on each StatisticColumn.
 *
 * @param table - The table from the spikecatcher response
 * @param requestedStats - The stat columns that are currently enabled
 * @param valueUom - The unit of measure for the series (used to filter string-incompatible stats)
 * @returns A map from stat key to extracted value
 */
export function extractStatsFromTable(
  table: { headers: Array<{ name: string }>; data: unknown[][] },
  requestedStats: ReadonlyArray<StatisticColumn>,
  valueUom?: string,
): Record<string, unknown> {
  const row = table.data[0];
  if (!row) return {};

  return Object.fromEntries(
    requestedStats
      .filter((stat) => stat.headerName && (valueUom !== STRING_UOM || stat.isStringCompatible))
      .map(
        (stat) =>
          [stat.key.split('.').pop()!, row[table.headers.findIndex((h) => h.name === stat.headerName)]] as const,
      )
      .filter(([, value]) => value !== undefined),
  );
}
